<template>
  <div>
    <Sticky>
      <nav
        class="navbar navbar-horizontal navbar-expand-lg py-0"
        style="background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%); border: none;"
      >
        <div class="container-fluid">
          <div
            class="navbar-brand text-dark"
            :class="$route.path !== '/home' ? 'd-flex justify-content-between' : ''
              "
          >
            <!-- <div
              class="d-flex flex-column banking-icons my-auto ml-1 mr-3"
              v-if="$route.path !== '/auth/login'"
            >
              <i
                class="fas fa-chevron-left mx-auto my-1 text-xl text-dark"
                @click=" $router.go(-1)"
                v-if="$route.path !== '/home'"
              ></i>
            </div> -->
            <img
              src="https://storage.googleapis.com/spacetech2/skk/shwekutkai-new.avif"
              alt=""
              @click=" $router.push('/home')"
            />
            <!-- LOGO -->
          </div>
          <div class="d-flex align-items-center navbar-toolbar">
            <div
              class="d-flex"
              v-if="$route.path !== '/auth/login' && authUser"
            >

              <span class="my-auto pr-3 navbar-balance">
                <span
                  class="text-sm text-uppercase"
                  style="color: #B7AAAA"
                >
                  <img
                    loading="lazy"
                    class="coin"
                    src="https://storage.googleapis.com/spacetech2/phoenix888/coin.png"
                    alt=""
                  >
                </span>
                <span class="text-dark text-md">
                  <b>{{ Number($store.state.authUser.amount).toLocaleString() }}</b> MMK
                </span>
              </span>
            </div>

            <div class="navbar-actions">
              <button
                type="button"
                class="navbar-download-btn"
                aria-label="Download app"
                @click="appInstall()"
              >
                <img
                  loading="lazy"
                  src="https://storage.googleapis.com/spacetech2/shwemyanmar/download.png"
                  alt=""
                >
              </button>

              <div
                v-if="!$store.state.authUser.name"
                class="navbar-auth-actions"
              >
                <button
                  type="button"
                  class="navbar-btn navbar-btn--quick"
                  @click="quickLogin"
                >
                  <span v-if="!isQuickLogin">
                    <i class="fas fa-bolt navbar-btn__icon"></i>{{ $t('auth.quick_login') }}
                  </span>
                  <Loading
                    v-else
                    color="#1e1b4b"
                    size="14"
                    class="px-1 py-0"
                  />
                </button>

                <button
                  type="button"
                  class="navbar-btn navbar-btn--gold"
                  @click="$router.push('/auth/register')"
                >
                  {{ $t('auth.sign_up') }}
                </button>

                <button
                  type="button"
                  class="navbar-btn navbar-btn--gold"
                  @click="$router.push('/auth/login')"
                >
                  {{ $t('auth.login') }}
                </button>
              </div>
            </div>

            <!-- <div class="nav-link px-1 pl-3 mx-0 d-flex justify-content-between">
              <a href="#" @click="showTopImage()" style="position: relative">
                <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/luckywin/icons/notification%20(1).png" style="width: 25px;">
              </a>
            </div>

            <van-popup v-model="showTop" round position="top" :style="{ height: '40%' }">
              <h3 class="pl-3 py-3">Latest Messages</h3>
                <div v-for="(list, index) in messages" :key="index" class="mx-4 py-3" style="border-bottom: 1px solid #CFCFCF" v-show="messages.length > 0">
                  <div class="d-flex justify-content-between">
                    <h4>{{ list.title }}</h4><h4>{{ timeFormat(list.created_at) }}</h4>
                  </div>
                  <span class="text-sm">{{ list.message }}</span>
                </div>
                <van-empty description="No Notifications Yet!" v-show="messages.length === 0"/>
            </van-popup> -->

            <!-- <div class="nav-link px-1 mx-0 d-flex justify-content-between">
              <a href="https://t.me/hulk333vip">
                <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/hulk333/icons/telegram%20(1).png" style="width: 25px;">
              </a>
            </div> -->

            <!-- Language -->
            <div
              class="nav-link d-flex justify-content-between px-1 navbar-lang"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <div id="navbar-language">
                <img
                  :src="$t('images.lang-img')"
                  alt=""
                  class="navbar-lang__flag"
                />
              </div>
            </div>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="navbar-language"
            >
              <a
                class="dropdown-item"
                @click="setLangLocalstorage('en')"
              ><img
                  src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />
                {{ $t("en") }}</a>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                @click="setLangLocalstorage('mm')"
              ><img
                  src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t('mm') }}</a>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                @click="setLangLocalstorage('cn')"
              ><img
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t("cn") }}</a>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                @click="setLangLocalstorage('th')"
              ><img
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                  alt=""
                  class="mr-2"
                  style="width: 20px; height: 20px"
                />{{ $t("th") }}</a>
            </div>
            <!-- <div class="my-auto pr-2" v-if="alreadyGranted && authUser">
                    <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/b067eede-486d-4336-e303-968134d62f00/public" style="width: auto; height: 35px;" alt="" @click=" askNotificationPermission()">
                  </div> -->
          </div>

        </div>
      </nav>
    </Sticky>
  </div>
</template>
<script>
import { Toast, Dialog, Sticky, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Sticky, Loading },
  data() {
    return {
      messages: [],
      showTop: false,
      // imageLink: `https://ui-avatars.com/api/?name=${this.$store.state.authUser.email}&background=0D8ABC&color=fff`,
      isLogged: false,
      authUser: null,
      alreadyGranted: true,
      isQuickLogin: false,
    };
  },
  computed: {
    isPlay2Subdomain() {
      if (typeof window === 'undefined') return false;
      const host = window.location.hostname.toLowerCase();
      return host === 'play2' || host.startsWith('play2.');
    },
    isPlaySubdomain() {
      if (typeof window === 'undefined') return false;
      const host = window.location.hostname.toLowerCase();
      return host === 'play' || host.startsWith('play.');
    },
    showQuickLogin() {
      return this.isPlaySubdomain || this.isPlay2Subdomain;
    },
    playHostPlatform() {
      if (this.isPlay2Subdomain) return 'Telegram';
      if (this.isPlaySubdomain) return 'TikTok';
      return null;
    },
  },
  methods: {
    appInstall() {
      const userAgent = navigator.userAgent;

      // console.log(userAgent);

      if (/android/i.test(userAgent)) {
        window.location.href = 'https://shorturl.at/yE010';
      } else {
        // Optional: Show a message or fallback
        alert('Unsupported device.');
      }
    },
    timeFormat(time) {
      return moment(time).startOf('hour').fromNow();
    },
    async getMessages() {
      try {
        const res = await axios.get('/messages');
        this.messages = res.data.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    showTopImage() {
      this.showTop = !this.showTop;
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    askNotificationPermission() {
      Notification.requestPermission().then(async (permission) => {
        if (permission === 'granted') {
          this.alreadyGranted = false;
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission granted!'
              : 'အသိပေးချက်အတည်ပြုပြီးပြီ'
          );
        } else {
          alert(
            this.$store.state.language === 'en'
              ? 'Notification permission denied!'
              : 'အသိပေးချက်အတည်ပြုမပြီးပြီ'
          );
        }
      });
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === '/home') {
            this.$router.go();
          } else {
            this.$router.push('/home');
            this.$router.go();
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    closeNavCollapse() {
      $('#navbar-default').collapse('hide');
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language
      $('#navbar-default').collapse('hide');
    },
    redirectLink(link) {
      this.$router.push(`/${link}`).catch(() => { });
      $('#navbar-default').collapse('hide');
    },
    redirectRoute(path) {
      if (path === '2d') {
        this.$router.push('/user/2d');
      } else {
        this.$router.push('/user/3d');
      }
      return true;
    },
    async quickLogin() {
      this.isQuickLogin = true;
      try {
        const deviceUuid = localStorage.getItem('device_uuid');
        const res = await this.axios.post('/auth/login-with-device', {
          device_uuid: deviceUuid,
          referralCode: localStorage.getItem('referralCode'),
        });
        localStorage.setItem('token', res.data.token);
        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        this.axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
        await this.fetchUser();
        this.authUser = this.$store.state.authUser;

        if (res.data.is_first_time === 1) {
          // this.playHostPlatform ||
          const platform =
            this.$route.query.ref ||
            this.$route.query.referrer ||
            localStorage.getItem('user_platform_ref');
          if (platform) {
            try {
              await this.axios.post('/auth/update-user-platform', {
                user_platform: platform.toLowerCase(),
              });
            } catch (err) {
              console.error('Failed to update platform via query router param:', err);
            }
          }
        }

        this.$router.push('/home').catch(() => { });
        Toast.success('Success!');
      } catch (err) {
        Toast.fail(this.$t('auth.fail_message'));
      }
      this.isQuickLogin = false;
    },
  },
  async mounted() {
    // this.getMessages();
    // if(window.Notification.permission === 'granted') {
    //   this.alreadyGranted = false;
    // }

    this.authUser = await this.fetchUser();
    if (this.authUser) {
      this.isLogged = true;
    }
  }
};
</script>
<style scoped>
/* CSS */
.login-btn {
  background: transparent;
  border: 1px solid #0d5c2e;
  border-radius: 3px;
  padding: .3rem 1.5rem;
  color: #0d5c2e;
}

.coin {
  height: 1.3rem;
  margin-top: -0.25rem;
  margin-right: 0.4rem;
  animation: flip-coin-49989627 2.5s linear infinite;
  animation-delay: 0s;
  animation-direction: normal;
  animation-fill-mode: none;
  animation-play-state: running;
  transform-style: preserve-3d;
  /* Keeps the 3D effect */
}

/* Define the keyframes for the 3D flip animation */
@keyframes flip-coin-49989627 {
  0% {
    transform: rotateY(0deg);
    /* Front face */
  }

  50% {
    transform: rotateY(180deg);
    /* Back face */
  }

  100% {
    transform: rotateY(360deg);
    /* Front face again */
  }
}

.navbar {
  padding: 3px;
  padding-left: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  /* border-bottom: 2px solid black; */
}

.navbar-horizontal .navbar-brand img {
  height: 40px;
}

.nav-link {
  cursor: pointer;
}

.navbar-brand.brand-text {
  font-size: 20px;
  color: #16a34a;
  margin-left: 0px;
  margin-right: 10px;
}

.navbar-brand {
  font-size: 16px;
  margin-left: 20px;
  margin-right: 20px;
  cursor: pointer;
}

.dropdown-item {
  cursor: pointer;
}

.bg-default {
  background-color: #02133E !important;
}

.navbar-toolbar {
  gap: 0.35rem;
  flex-shrink: 0;
}

.navbar-balance {
  border-right: 1px solid #d4d4d4;
}

.navbar-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.navbar-download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.65rem;
  height: 1.65rem;
  padding: 0;
  border: 1px solid rgba(201, 164, 0, 0.35);
  background: linear-gradient(145deg, #fffbeb 0%, #fde68a 100%);
  border-radius: 50%;
  box-shadow: 0 1px 4px rgba(140, 106, 0, 0.18);
  cursor: pointer;
}

.navbar-download-btn img {
  width: 0.95rem;
  height: 0.95rem;
  object-fit: contain;
}

.navbar-auth-actions {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.25rem;
  flex-shrink: 0;
}

.navbar-btn {
  border: none;
  border-radius: 999px;
  padding: 0.28rem 0.55rem;
  font-size: 0.68rem;
  font-weight: 600;
  line-height: 1.15;
  white-space: nowrap;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

.navbar-btn__icon {
  font-size: 0.6rem;
  margin-right: 0.15rem;
}

.navbar-btn--quick {
  background: linear-gradient(135deg, #fde047 0%, #facc15 45%, #eab308 100%);
  color: #1e1b4b;
}

.navbar-btn--gold {
  background: linear-gradient(135deg, #8c6a00 0%, #c9a400 50%, #f2c94c 100%);
  color: #fff;
}

.navbar-lang {
  margin-left: 0.15rem;
}

.navbar-lang__flag {
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 50%;
  border: 1px solid rgba(201, 164, 0, 0.25);
}

@media (max-width: 767.98px) {
  .navbar-brand {
    font-size: 14px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .navbar-horizontal .navbar-brand img {
    height: 34px;
  }

  .navbar-toolbar {
    gap: 0.2rem;
  }

  .navbar-auth-actions {
    gap: 0.18rem;
  }

  .navbar-download-btn {
    width: 1.45rem;
    height: 1.45rem;
  }

  .navbar-download-btn img {
    width: 0.8rem;
    height: 0.8rem;
  }

  .navbar-btn {
    padding: 0.3rem 0.38rem;
    font-size: 0.8rem;
  }

  .navbar-btn__icon {
    font-size: 0.52rem;
    margin-right: 0.1rem;
  }

  .navbar-lang__flag {
    width: 1.2rem;
    height: 1.2rem;
  }
}
</style>
